<!-- 报到签到 -->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛程</el-breadcrumb-item>
      <el-breadcrumb-item>全国总决选</el-breadcrumb-item>
      <el-breadcrumb-item>无组别签到抽签</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <div class="page-title">无组别-签到抽签</div>
    <div class="page-title">
      总人数：<span>100</span>
      已签到：<span>50</span>
      未签到：<span>50</span>
    </div>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签到状态" prop="isRace">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.isRace"
              >
                <el-option label="未签到" :value="0"></el-option>
                <el-option label="已签到" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="物料领取" prop="signMateriel">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.signMateriel"
              >
                <el-option label="未领取" :value="0"></el-option>
                <el-option label="已领取" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button plain type="primary" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">签到列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="setMatchNum">一键生成抽签号码</el-button>
        </el-col>
      </el-row>
        <el-table
          header-cell-class-name="tableHeaderStyle"
          :data="dataList"
          border
          stripe
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="赛季" prop="season"></el-table-column>
          <el-table-column label="姓名" prop="userName"></el-table-column>
          <el-table-column label="学校" prop="schoolName"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column
            label="组别"
            prop="enrollmentLevel"
            :formatter="levelFormatter"
          ></el-table-column>
          <el-table-column
            label="年级"
            prop="grade"
            :formatter="gradeFormatter"
          ></el-table-column>
          <el-table-column label="号码牌" prop="matchNum">
            <template slot-scope="scope">
              <span class="num">{{ addZero(scope.row.matchNum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签到状态" prop="signReport">
            <template slot-scope="scope">
              <el-tag :type="scope.row.signReport ? 'success' : 'danger'" size="mini">{{scope.row.signReport ? '已签到' : '未签到'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="物料领取" prop="signMateriel">
            <template slot-scope="scope">
              <el-tag :type="scope.row.signMateriel ? 'success' : 'warning'" size="mini">{{scope.row.signMateriel ? '已领取' : '未领取'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editFn(scope.row)"
                >修改状态</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    </el-card>
    <el-dialog
      title="修改签到状态"
      :visible.sync="dialogVisible"
      @close="dialogVisible = false"
      width="40%"
    >
      <div class="row">
        <div class="col" v-for="(value, key) in editInfo" :key="key">
          <div class="label">{{ key }}</div>
          <div class="value">{{ value }}</div>
        </div>
        <div class="col">
          <div class="label">比赛号码</div>
          <div class="value">

          </div>
        </div>
        <div class="col">
          <div class="label">签到抽签状态</div>
          <div class="value">
            <el-switch v-model="isRace"></el-switch>
            {{ isRace ? '已签到' : '未签到' }}
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="submit">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: this.$chnEngStatusCode.raceScheduleFinal,
        phone: '',
        userName: '',
        isRace: ''
      },
      dataList: [],
      dialogVisible: false,
      editInfo: {}
    }
  },
  created () {
    // this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      this.$http.get('/national/queryNationalGroupList', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data
        }
      })
    },
    // 生成号码牌
    setMatchNum () {
      const haveDone = this.dataList.find(item => item.matchNum)
      console.log(haveDone)
      if (haveDone) {
        this.$confirm('比赛号码牌已生成，请慎重操作。是否重新生成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.setFn()
        }).catch(() => {
        })
      } else {
        this.setFn()
      }
    },
    setFn () {
      this.$http.post('/national/generateNationalNumberCards', {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season
      }).then(res => {
        if (res.code === 200) {
          this.getList()
        }
      })
    },
    // 修改状态
    editFn (item) {
      const obj = {}
      obj['姓名'] = item.userName
      obj['手机号'] = item.phone
      obj['学校'] = item.schoolName
      obj['年级'] = this.gradeFormatter(item)
      obj['组别'] = this.levelFormatter(item)
      this.editInfo = obj
      this.id = item.id
      this.signMateriel = item.signMateriel === 1
      this.signReport = item.signReport === 1
      this.matchNum = item.matchNum
      this.dialogVisible = true
    },
    search () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    levelFormatter (data) {
      return data.level ? this.dict_group.find(item => item.dictCode === data.level).dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    submit () {
      this.$http.post('/national/updateNationalSignUp', {
        id: this.id,
        signMateriel: this.signMateriel ? 1 : 0,
        signReport: this.signReport ? 1 : 0
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.getList()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-title{
  font-size: 18px;
  color: #000;
  margin-bottom: 10px;
  text-align: center;
  span {
    margin-right: 20px;
    color: #409EFF;
    font-size: 20px;
  }
}
.num {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.col{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.label{
  width: 80px;
  text-align: right;
  margin-right: 12px;
}
.value-num{
  font-size: 26px;
  font-weight: bold;
  color: #000;
}
.btn{
  text-align: center;
}
</style>
